<template>
<ul class="password-requirements">
    <li
    v-for="item in items"
    :key="item.key"
    class="password-requirements__item"
    :class="{ 'password-requirements__item--met': item.met }"
    >
        <font-awesome-icon :icon="item.met ? 'check' : 'times'" class="password-requirements__icon"></font-awesome-icon>
        {{ item.label }}
    </li>
</ul>
</template>

<script>
import { passwordRequirements } from '@/utils/passwordPolicy.js'

export default {
  name: 'PasswordRequirements',
  props: {
    password: {
      type: String,
      default: ''
    }
  },
  computed: {
    items: function () {
      var pw = this.password || ''
      return passwordRequirements.map(function (req) {
        return { key: req.key, label: req.label, met: req.test(pw) }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password-requirements {
    list-style: none;
    margin: 0.5rem 0;
    padding: 0;
    font-size: 0.82rem;
    color: var(--color-ghost);

    &__item {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.1rem 0;

        &--met {
            color: var(--color-success);
        }
    }

    &__icon {
        font-size: 0.7rem;
        flex-shrink: 0;
    }
}
</style>
